<ng-template #PrimaryTemplate>
  <div
    class="priority"
    [fxFlex]="isDesktop && windowSize !== windowSizes.XS && formData.standardEnabled ? 50 : 100"
    fxLayout="column"
    style="background: {{ formData.backgroundColorPrimary }}; color: {{ formData.textColorPrimary }}"
  >
    <h1 style="background: {{ formData?.titleBackgroundColorPrimary }}; color: {{ formData?.titleTextColorPrimary }}">
      {{ formData.titlePrimary }}
      <mat-icon svgIcon="prioritystar" style="background: {{ formData?.stripeBackgroundColor }}" />
      <span class="triangle-left" style="border-color: transparent {{ formData?.stripeBackgroundColor }} transparent transparent"></span>
      <span class="triangle-right" style="border-color: {{ formData?.stripeBackgroundColor }} transparent transparent transparent"></span>
    </h1>
    <div class="logo" fxLayout="row" fxLayoutGap="10px" style="background: {{ formData?.logoBackgroundColorPrimary }}">
      <div class="img img-priority-charity" fxFlex="40" fxLayoutAlign="end center">
        <img [src]="formData.logo || charity.logo" />
      </div>
      <span fxLayoutAlign="center center" fxFlex style="color: {{ formData.backgroundColorPrimary }}">
        <mat-icon>add</mat-icon>
      </span>
      <div class="img" fxFlex="40" fxLayoutAlign="start center">
        <div class="third-party-wrapper">
          <mat-icon svgIcon="rspl-new-logo" />
          @if (formData.version === splitScreenVersions.V2) {
            <p class="third-party">3RD party veteran owned</p>
          }
        </div>
      </div>
    </div>
    @if (formData?.version === splitScreenVersions.V1 && !(formData.textPrimary?.trim()?.length > 0)) {
      <ul>
        <li>
          <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
          Pickups as soon as 2 business days (Mon-Sat), subject to timeslot availability
        </li>
        <li>
          <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
          Can pick up from multiple floors
        </li>
        <li>
          <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
          Can disassemble furniture
        </li>
        <li>
          <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
          Items of ANY condition accepted
        </li>
        <li>
          <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
          Cost of the pickup for the charity is covered (Fee Based Service)
        </li>
      </ul>
    }

    @if (formData?.version === splitScreenVersions.V1 && formData.textPrimary?.trim()?.length > 0) {
      <ul>
        @for (el of textPrimaryValues; track el) {
          <li>
            <span class="bullet" style="background: {{ formData?.bulletColorPrimary }}"></span>
            {{ el }}
          </li>
        }
      </ul>
    }

    @if (formData?.version === splitScreenVersions.V2) {
      <ul>
        <li>
          <mat-icon svgIcon="ss-primary-floor" />
          Pickups from any floor
        </li>
        <li>
          <mat-icon svgIcon="ss-primary-disassembly" />
          Item disassembly and removal
        </li>
        <li>
          <mat-icon svgIcon="ss-primary-items" />
          All items are picked up for a fee
        </li>
        <li>
          <mat-icon svgIcon="ss-primary-time" />
          Donation pickups in 1-3 days
        </li>
      </ul>
    }
    @if (formData?.version === splitScreenVersions.V2 && formData.textPrimary?.trim()?.length > 0) {
      <p class="standard-additional-text" [innerHTML]="textPrimaryValue"></p>
    }
    <div class="btn-wrapper" fxLayout="row" fxFlex fxLayoutAlign="center end">
      <button
        mat-button
        class="btn-block"
        style="background: {{ formData.btnBackgroundColorPrimary }}; color: {{ formData.btnTextColorPrimary }}; cursor: {{
          formData.primaryReady ? 'pointer' : 'default'
        }}"
      >
        @if (formData.primaryReady) {
          <span>{{ formData.buttonPrimary ? formData.buttonPrimary : 'Schedule Now!' }}</span>
        }
        @if (!formData.primaryReady) {
          <span>Coming Soon!</span>
        }
      </button>
    </div>
  </div>
</ng-template>
<ng-template #StandardTemplate>
  @if (formData.standardEnabled) {
    <div
      class="free"
      [fxFlex]="isDesktop ? 50 : 100"
      fxLayout="column"
      style="background: {{ formData.backgroundColor }}; color: {{ formData.textColor }}"
    >
      <h1 style="background: {{ formData?.titleBackgroundColor }}; color: {{ formData?.titleTextColor }}">
        {{ formData.title }}
      </h1>
      <div class="logo" fxLayout="row" fxLayoutAlign="center center" style="background: {{ formData?.logoBackgroundColor }}">
        <div class="img" fxLayoutAlign="center center">
          <img [src]="formData.logo || charity.logo" />
        </div>
      </div>
      @if (formData?.version === splitScreenVersions.V1 && !(formData.text?.trim()?.length > 0)) {
        <ul>
          <li>
            <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
            Pickup services are free to you
          </li>
          <li>
            <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
            Ground floor disassembly only
          </li>
          <li>
            <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
            Items accepted based on condition
          </li>
          <li>
            <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
            Scheduling based on availability
          </li>
          @if (formData.showRestrictedItems) {
            <li>
              <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
              <a href="{{ formData.restrictedItemsUrl }}" style="color: {{ formData.textColor }}" target="_blank">
                {{ formData.restrictedItemsText }}
              </a>
            </li>
          }
        </ul>
      }
      @if (formData?.version === splitScreenVersions.V1 && formData.text?.trim()?.length > 0) {
        <ul>
          @for (el of textValues; track el) {
            <li>
              <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
              {{ el }}
            </li>
          }
          @if (formData.showRestrictedItems) {
            <li>
              <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
              <a href="{{ formData.restrictedItemsUrl }}" style="color: {{ formData.textColor }}" target="_blank">
                {{ formData.restrictedItemsText }}
              </a>
            </li>
          }
        </ul>
      }
      @if (formData?.version === splitScreenVersions.V2 && screening && pickUp) {
        <ul>
          <li>
            <mat-icon
              [ngClass]="{ gray: screening.floor !== 'any' }"
              [svgIcon]="screening.floor === 'any' ? 'ss-primary-floor' : 'ss-standard-floor'"
            ></mat-icon>
            {{ screening.floor === 'curbside' ? 'Curbside pickups only' : '' }}
            {{ screening.floor === 'first' ? 'Pickups from 1st floor only, no staircases' : '' }}
            {{ screening.floor === 'second' ? 'Pickups from 2nd floor and below' : '' }}
            {{ screening.floor === 'any' ? 'Pickups from any floor' : '' }}
          </li>
          <li>
            <mat-icon
              [ngClass]="{ gray: !screening.disassembly }"
              [svgIcon]="screening.disassembly ? 'ss-primary-disassembly' : 'ss-standard-disassembly'"
            ></mat-icon>
            {{ screening.disassembly ? 'Item disassembly and removal' : 'Self disassembly required' }}
          </li>
          <li>
            <mat-icon class="gray" svgIcon="ss-standard-items" />
            <div fxLayout="column">
              <label>Donatable items only</label>
              @if (screening.restrictedItems.length > 0) {
                <a>See restricted items list</a>
              }
            </div>
          </li>
          <li>
            <mat-icon
              [ngClass]="{ gray: screening.leadTime !== '3 days or less' }"
              [svgIcon]="screening.leadTime === '3 days or less' ? 'ss-primary-time' : 'ss-standard-time'"
            ></mat-icon>
            Donation pickups in {{ screening.leadTime }}
          </li>
        </ul>
      }
      @if (pickUp && formData?.version === splitScreenVersions.V2 && textValue) {
        <p class="standard-additional-text" [innerHTML]="textValue"></p>
      }
      @if (!pickUp && formData?.version === splitScreenVersions.V2 && textValues.length > 0) {
        <ul>
          @for (el of textValues; track el) {
            <li>
              <span class="bullet" style="background: {{ formData?.bulletColor }}"></span>
              {{ el }}
            </li>
          }
        </ul>
      }
      @if (formData?.version === splitScreenVersions.V2 && formData.showRestrictedItems) {
        <p class="donation-guidlines" style="color: {{ formData.textColor }}">
          Please see our
          <a href="{{ formData.restrictedItemsUrl }}" target="_blank">Donation Guidelines</a>
          before visiting one of our donation centers.
        </p>
      }
      <div class="btn-wrapper" fxLayout="row" fxFlex fxLayoutAlign="center end">
        @if (formData.standardReady) {
          <a
            mat-button
            class="btn-block"
            [href]="formData.url"
            target="_blank"
            style="background: {{ formData.btnBackgroundColor }}; color: {{ formData.btnTextColor }}"
          >
            @if (formData.standardReady) {
              <span>{{ formData.button ? formData.button : 'Request Approval' }}</span>
            }
          </a>
        }
        @if (!formData.standardReady) {
          <button mat-button class="btn-block" style="background: {{ formData.btnBackgroundColor }}; color: {{ formData.btnTextColor }}">
            @if (!formData.standardReady) {
              <span>Coming Soon!</span>
            }
          </button>
        }
      </div>
    </div>
  }
</ng-template>
<ng-template #PreviewTemplate>
  @if ([splitScreenVersions.V1, splitScreenVersions.V2].includes(formData.version)) {
    <div class="space" fxLayoutAlign="center center" fxLayout="column">
      <div
        fxLayoutGap="30px"
        class="cards {{ formData?.version }}"
        [fxLayout]="isDesktop && windowSize !== windowSizes.XS ? 'row' : 'column'"
      >
        <ng-container [ngTemplateOutlet]="formData?.reverse ? StandardTemplate : PrimaryTemplate"></ng-container>
        <ng-container [ngTemplateOutlet]="formData?.reverse ? PrimaryTemplate : StandardTemplate"></ng-container>
      </div>
    </div>
    <div fxLayout="row" class="social" fxLayoutGap="20px" fxLayoutAlign="end end">
      <a href="https://www.facebook.com/resupplyapp/?eid=ARDseOOUc71V0lp5-0QTY42vLkLjbxneImEoXfK9y7BqflDTH3-sM7O9fvG9ED82tA4ZmakojbSaRboA">
        <mat-icon svgIcon="facebook" />
      </a>
      <a href="https://www.instagram.com/resupplyme/">
        <mat-icon svgIcon="instagram" />
      </a>
      <a href="https://www.linkedin.com/company/resupplyme/?viewAsMember=true">
        <mat-icon svgIcon="linkedin" />
      </a>
    </div>
  }
  @if ([splitScreenVersions.V3A, splitScreenVersions.V3B].includes(formData.version)) {
    <div id="v3-preview-container" fxLayout="column">
      <img
        [src]="
          '/assets/split-screen-v3/preview/' +
          (formData.version === splitScreenVersions.V3A ? 'short/' : 'long/') +
          (isDesktop ? 'lg/' : 'sm/') +
          '1.webp'
        "
      />
      @if (formData.version === splitScreenVersions.V3A && formData.discounts) {
        <img [src]="'/assets/split-screen-v3/preview/short/' + (isDesktop ? 'lg/' : 'sm/') + 'discount.webp'" />
      }
      @if (formData.standardEnabled) {
        <img
          [src]="
            '/assets/split-screen-v3/preview/' +
            (formData.version === splitScreenVersions.V3A ? 'short/' : 'long/') +
            (isDesktop ? 'lg/' : 'sm/') +
            'charity.webp'
          "
        />
      }
      @if (formData.version === splitScreenVersions.V3B) {
        <img [src]="'/assets/split-screen-v3/preview/long/' + (isDesktop ? 'lg/' : 'sm/') + '2.webp'" />
      }
      @if (formData.version === splitScreenVersions.V3B && formData.discounts) {
        <img [src]="'/assets/split-screen-v3/preview/long/' + (isDesktop ? 'lg/' : 'sm/') + 'discount.webp'" />
      }
      @if (formData.version === splitScreenVersions.V3B) {
        <img [src]="'/assets/split-screen-v3/preview/long/' + (isDesktop ? 'lg/' : 'sm/') + '3.webp'" />
      }
    </div>
  }
  @if (splitScreenVersions.V4 === formData.version) {
    <div class="iframe-wrapper">
      <iframe [src]="linkToSplitLanding | safe" [style]="iframeStyle"></iframe>
    </div>
  }
</ng-template>
@if (config) {
  <div fxLayout="column" fxLayoutGap="30px">
    <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="30px">
      @if (config) {
        <app-split-screen-form [charity]="charity" [config]="config" (formChange)="formDataChange($event)" />
      }
      @if (windowSize === windowSizes.XS) {
        <rspl-card cardTitle="Preview" class="landing-preview" []>
          <ng-container *ngTemplateOutlet="PreviewTemplate"></ng-container>
        </rspl-card>
      }
      <div style="width: 100%; overflow: auto">
        <div>
          @if (windowSize !== windowSizes.XS) {
            <div fxLayout="column" fxLayoutGap="30px" fxFlex="100" fxFlex.gt-sm="70" style="overflow: auto">
              <div fxLayout="row" fxLayoutGap="1" fxLayoutAlign="center center" class="preview-buttons">
                <mat-button-toggle-group (valueChange)="setPreview($event)" [disabled]="!formData?.enabled">
                  <mat-button-toggle value="desktop" [checked]="isDesktop">Desktop</mat-button-toggle>
                  <mat-button-toggle value="mobile" [checked]="!isDesktop">Mobile</mat-button-toggle>
                </mat-button-toggle-group>
                @if (isDesktop && !fullscreen) {
                  <button
                    mat-raised-button
                    [disabled]="!formData?.enabled"
                    (click)="toggleFullScreen()"
                    class="fullscreen-btn"
                    type="button"
                  >
                    @if (!fullscreen) {
                      <mat-icon>fullscreen</mat-icon>
                    }
                    @if (!fullscreen) {
                      <span>Full Screen</span>
                    }
                  </button>
                }
              </div>
              <div fxLayout="row" fxLayoutAlign="center">
                @if (isDesktop) {
                  <rspl-card
                    [class]="preview + ' landing-preview'"
                    [ngClass]="{ fullscreen: fullscreen }"
                    [ngClass]="{ disabled: !formData?.enabled }"
                  >
                    @if (isDesktop && fullscreen) {
                      <button mat-raised-button (click)="toggleFullScreen()" class="fullscreen-btn" type="button">
                        @if (fullscreen) {
                          <mat-icon>fullscreen_exit</mat-icon>
                        }
                        @if (fullscreen) {
                          <span>Exit Full Screen</span>
                        }
                      </button>
                    }
                    <ng-container *ngTemplateOutlet="PreviewTemplate"></ng-container>
                  </rspl-card>
                }
                @if (!isDesktop) {
                  <div
                    [class]="preview"
                    [ngClass]="{
                      disabled: !formData?.enabled,
                      v3: [splitScreenVersions.V3A, splitScreenVersions.V3B, splitScreenVersions.V4].includes(formData.version),
                    }"
                    class="mobile"
                  >
                    <div>
                      <ng-container *ngTemplateOutlet="PreviewTemplate"></ng-container>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>

    <div fxLayout="row" fxLayoutAlign="end center" class="save-button {{ app }}">
      <button class="primary-btn" mat-raised-button rsplDisableDoubleClick (click)="submitForm()">Save Configuration</button>
    </div>
  </div>
}
